















































import { Vue, Component, Prop } from 'vue-property-decorator';
import RoundButton from '@/components/RoundButton.vue';
import { api } from '@/api';

@Component({
  components: {
    RoundButton
  }
})
export default class FileUpload extends Vue {
  // Props
  @Prop({ type: String, default: '' }) public accept!: string;
  @Prop(String) public apiUrl!: string;
  @Prop({ type: Boolean, default: true }) public multiple!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: true }) public readonly customSave!: boolean;

  public files: any = [];
  public dragging = false;
  public errorMessages = '';

  public getPlaceholder() {
    if (!this.isReadOnly) {
      if (this.multiple) {
        return 'Sleep of selecteer de bestanden hier';
      } else {
        return 'Sleep of selecteer het bestand hier';
      }
    } else {
      return '';
    }
  }

  public deleteFile(index) {
    this.errorMessages = '';
    if (this.multiple) {
      this.files.splice(index, 1);
    } else {
      this.files = null;
    }
  }

  public addDropFile(e) {
    if (!this.isReadOnly) {
      this.errorMessages = '';
      this.dragging = false;
      const transfer: any = e.dataTransfer;
      const files: FileList = transfer.files;
      if (!this.multiple && (this.files.length > 0 || files.length > 1)) {
        this.errorMessages = 'Het maximaal aantal toegelaten bestanden is 1.';
      } else {
        const acceptedFiles = this.accept.split(/[\s,]+/); // Remove spaces
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < files.length; i++) {
          let accepted = false;
          // tslint:disable-next-line: prefer-for-of
          for (let j = 0; j < acceptedFiles.length; j++) {
            if (files[i].type.match(acceptedFiles[j])) {
              accepted = true;
              if (this.multiple) {
                this.files.push(files[i]);
              } else {
                this.files = files[i];
              }
              break;
            }
          }
          if (!accepted) {
            this.errorMessages =
              '1 of meerdere bestanden zijn niet toegevoegd wegens fout formaat.';
          }
        }
      }
    }
  }

  public save() {
    this.errorMessages = '';
    const formData = new FormData();
    if (this.files) {
      if (this.multiple) {
        // tslint:disable-next-line: forin
        for (const x in this.files) {
          const file: Blob = this.files[x];
          formData.append('file', file);
        }
      } else {
        const file: Blob = this.files;
        formData.append('file', file);
      }
    }
    api.uploadFile(this.$store, this.apiUrl, formData);
    this.files = [];
  }
}
